exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-box[data-v-24fb5700]{min-height:calc(100vh - 90px)}.station-header .el-icon-arrow-left[data-v-24fb5700]{cursor:pointer}.p20[data-v-24fb5700]{padding:0 20px}\n", ""]);

// exports
